import { useEffect, useMemo, useState } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import Cookies from 'js-cookie'

export default function useShowUseMyPhone() {
  const flag = useFeatureFlag('identity_login_useMyPhone')

  const [fscLocation, setFscLocation] = useState(null)

  useEffect(() => {
    const extensionResponseHandler = (event) => {
      if (event?.data?.message === 'center_identities' && event?.data?.data) {
        const centerArray = event.data.data
        setFscLocation(centerArray[0]?.name || null)
      }
    }
    // Set up listener for events from FamilySearch Premium Sites extension
    window.addEventListener('message', extensionResponseHandler)

    // Send data request to FamilySearch Premium Sites extension
    window.dispatchEvent(new CustomEvent('getCurrentCenter'))

    return () => {
      window.removeEventListener('message', extensionResponseHandler)
    }
  }, [])

  return useMemo(() => isOn(flag, fscLocation), [flag, fscLocation])
}

export function isOn(flag, fscLocation) {
  const { config, treatment } = flag || {}
  if (treatment === 'on') {
    return true
  }
  if (treatment === 'fs_centers') {
    const ip = Cookies.get('fsgeo')
    if (config?.[ip] === 'on') {
      return true
    }
    if (fscLocation) {
      // enable the flag if the special "ALL" key-pair is 'on' otherwise check if the center where we are located is 'on'
      return config?.ALL === 'on' || config?.[fscLocation] === 'on'
    }
  }
  return false
}
